import React from "react"

import SubsectionContainer from "./SubsectionContainer"
import { SubsectionContent, SubsectionContentList } from "./SubsectionContent"

import { getSortedValuesByKeys } from "../utils/getSortedKeysByValues"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"

interface TreatmentApproachContentProps {
  therapyTypes: string[]
}

export const TreatmentApproachContent: React.FC<
  TreatmentApproachContentProps
> = ({ therapyTypes = [] }) => {
  const { cms: cmsContent, isReady: isCMSReady } = useCMSReady([
    "providerTherapyTypeMap",
  ])
  const providerTherapyTypeMap = cmsContent.providerTherapyTypeMap
  const sortedProviderTherapyList = getSortedValuesByKeys(
    therapyTypes,
    isCMSReady && providerTherapyTypeMap ? providerTherapyTypeMap : {},
  )

  return (
    <SubsectionContainer>
      <SubsectionContent>
        <SubsectionContentList listItems={sortedProviderTherapyList} />
      </SubsectionContent>
    </SubsectionContainer>
  )
}
